<template>
  <div class="axj_certification_body">
    <div v-show="true" class="axj_certification_body_do_cert">
      <div class="axj_certification_body_normal_item">
        <div class="axj_certification_body_normal_item_body">
          <div class="axj_certification_body_normal_item_body_label">
            <label class="notNull">账号昵称</label>
          </div>
          <div class="axj_certification_body_normal_item_body_input">
            <input ref="NickNameInput" @input="handleNickNameInput" v-model="certificationForm.NickName" placeholder="请输入账号昵称"></input>
          </div>
          <div ref="NickNameMessage" class="axj_certification_body_normal_item_body_message">
            <label>请输入账号昵称</label>
          </div>
        </div>
        <div class="axj_certification_body_normal_item_remark">
          <div class="axj_certification_body_normal_item_remark_label">
            <label>2-10个字符，尽量与机构名称或认证信息相符，请勿使用含特殊符号或含有营销推广信息的名称</label>
          </div>
        </div>
      </div>
      <div class="axj_certification_body_file_item">
        <div class="axj_certification_body_file_item_body">
          <div class="axj_certification_body_file_item_body_label">
            <label class="notNull">用户头像</label>
          </div>
          <div class="axj_certification_body_file_item_body_input">
              <axj-upload
                @success="uploadAvatarSuccess"
                tips="请选择文件"
                :pre-view-file-url="axjAvatarUploadConf.preViewFileUrl"
              ></axj-upload>
          </div>
          <div class="axj_certification_body_file_item_body_remark">
            <div class="axj_certification_body_file_item_body_remark_label">
              <label>要求清晰、健康、代表机构形象。请勿使用二维码，请尽量上传正方形图片，支持jpg/png，不超过2M</label>
            </div>
            <div class="axj_certification_body_file_item_body_remark_message_label">
              <label>请上传文件</label>
            </div>
          </div>
        </div>
      </div>
      <div class="axj_certification_body_normal_item">
        <div class="axj_certification_body_normal_item_body">
          <div class="axj_certification_body_normal_item_body_label">
            <label class="notNull">机构名称</label>
          </div>
          <div class="axj_certification_body_normal_item_body_input">
            <input ref="MechanismNameInput" v-model="certificationForm.MechanismName" placeholder="请输入机构名称"></input>
          </div>
          <div ref="MechanismNameMessage" class="axj_certification_body_normal_item_body_message">
            <label>请输入机构名称</label>
          </div>
        </div>
        <div class="axj_certification_body_normal_item_remark" v-show="false">
          <div class="axj_certification_body_normal_item_remark_label">
            <label>2-16个字，尽量与机构名称或认证信息相符，请勿使用含特殊符号或含有营销推广信息的名称</label>
          </div>
        </div>
      </div>
      <div class="axj_certification_body_normal_item">
        <div class="axj_certification_body_normal_item_body">
          <div class="axj_certification_body_normal_item_body_label">
            <label class="notNull">机构类型</label>
          </div>
          <div class="axj_certification_body_normal_item_body_select">
            <select v-model="certificationForm.MechanismType">
              <option value="0">高校</option>
            </select>
          </div>
          <div v-show="false" class="axj_certification_body_normal_item_body_message">
            <label>请输入账号昵称</label>
          </div>
        </div>
        <div v-show="false" class="axj_certification_body_normal_item_remark">
          <div class="axj_certification_body_normal_item_remark_label">
            <label>2-16个字，尽量与机构名称或认证信息相符，请勿使用含特殊符号或含有营销推广信息的名称</label>
          </div>
        </div>
      </div>
      <div class="axj_certification_body_file_item">
        <div class="axj_certification_body_file_item_body">
          <div class="axj_certification_body_file_item_body_label">
            <label class="notNull">组织机构代码证</label>
          </div>
          <div class="axj_certification_body_file_item_body_input">
            <axj-upload
              @success="uploadBusinessSuccess"
              tips="请选择文件"
              :pre-view-file-url="axjBusinessUploadConf.preViewFileUrl"
            ></axj-upload>
          </div>
          <div class="axj_certification_body_file_item_body_remark">
            <div class="axj_certification_body_file_item_body_remark_label">
              <label>
                请上传最新的资质证明， 像素要求1200*900px，
                正面照，资质无残缺信息。
                <label class="link" @click="handlePreView1">查看示例</label>

              </label>
            </div>
            <div class="axj_certification_body_file_item_body_remark_message_label">
              <label>请上传文件</label>
            </div>
          </div>
        </div>
      </div>
      <div class="axj_certification_body_file_item">
        <div class="axj_certification_body_file_item_body">
          <div class="axj_certification_body_file_item_body_label">
            <label class="notNull">机构认证申请公函</label>
          </div>
          <div class="axj_certification_body_file_item_body_input">
            <axj-upload
              @success="uploadLetterSuccess"
              tips="请选择文件"
              :pre-view-file-url="axjLetterUploadConf.preViewFileUrl"
            ></axj-upload>
          </div>
          <div class="axj_certification_body_file_item_body_remark">
            <div class="axj_certification_body_file_item_body_remark_label">
              <label>
                请下载填写  <el-link href="https://aixuejie-test.oss-cn-hangzhou.aliyuncs.com/axj_web_file/image/%E7%88%B1%E5%AD%A6%E7%95%8C%E6%9C%BA%E6%9E%84%E8%AE%A4%E8%AF%81%E5%85%AC%E5%87%BD.docx"><label class="link">《机构认证申请公函》</label></el-link>，填写完成后加盖红色公章，上传清晰的公函扫描件。</label>
            </div>
            <div class="axj_certification_body_file_item_body_remark_message_label">
              <label>请上传文件</label>
            </div>
          </div>
        </div>
      </div>
      <div class="axj_certification_body_normal_item">
        <div class="axj_certification_body_normal_item_body">
          <div class="axj_certification_body_normal_item_body_label">
            <label class="notNull">运营者真实姓名</label>
          </div>
          <div class="axj_certification_body_normal_item_body_input">
            <input ref="realNameInput" placeholder="请输入运营者真实姓名" v-model="certificationForm.RealName"></input>
          </div>
          <div ref="realNameMessage" class="axj_certification_body_normal_item_body_message">
            <label>请输入账号昵称</label>
          </div>
        </div>
        <div class="axj_certification_body_normal_item_remark">
          <div class="axj_certification_body_normal_item_remark_label">
            <label>请填写与《机构认证申请公函》上的运营者姓名一致，在认证审核过程中，将与该运营者联系核实</label>
          </div>
        </div>
      </div>
      <div class="axj_certification_body_normal_item">
        <div class="axj_certification_body_normal_item_body">
          <div class="axj_certification_body_normal_item_body_label">
            <label class="notNull">运营者身份证号</label>
          </div>
          <div class="axj_certification_body_normal_item_body_input">
            <input @input="handleIdCardInput" @keydown="handleIdCardKeyClick" ref="IdCardInput" placeholder="请输入运营者身份证号" v-model="certificationForm.IdCard" ></input>
          </div>
          <div ref="IdCardMessage" class="axj_certification_body_normal_item_body_message">
            <label>请输入正确的身份证号</label>
          </div>
        </div>
        <div class="axj_certification_body_normal_item_remark" v-show="false">
          <div class="axj_certification_body_normal_item_remark_label">
            <label>请填写与《机构认证申请公函》上的运营者姓名一致，在认证审核过程中，将与该运营者联系核实</label>
          </div>
        </div>
      </div>
      <div class="axj_certification_body_normal_item">
        <div class="axj_certification_body_normal_item_body">
          <div class="axj_certification_body_normal_item_body_label">
            <label class="notNull">运营者手机号码</label>
          </div>
          <div class="axj_certification_body_normal_item_body_input">
            <input @input="handlePhoneInput" @keydown="handlePhoneKeyClick" ref="PhoneInput" placeholder="请输入运营者手机号码" v-model="certificationForm.Phone"></input>
          </div>
          <div ref="PhoneMessage" class="axj_certification_body_normal_item_body_message">
            <label>请输入账号昵称</label>
          </div>
        </div>
        <div class="axj_certification_body_normal_item_remark">
          <div class="axj_certification_body_normal_item_remark_label" v-show="false">
            <label>请填写与《机构认证申请公函》上的运营者姓名一致，在认证审核过程中，将与该运营者联系核实</label>
          </div>
        </div>
      </div>
      <div class="axj_certification_body_yzm_item">
        <div class="axj_certification_body_yzm_item_body">
          <div class="axj_certification_body_yzm_item_body_label">
<!--            <label class="notNull">验证码</label>-->
          </div>
          <div class="axj_certification_body_yzm_item_body_input">
            <input  ref="CodeInput" v-model="certificationForm.Code" placeholder="请输入验证码" ></input>
          </div>
          <div class="axj_certification_body_yzm_item_body_button">
            <button @click="sendLetterCode">{{expiresTime==0?'获取短信验证码':expiresTime+'s重新获取'}}</button>
          </div>
          <div ref="CodeMessage" class="axj_certification_body_yzm_item_body_message">
            <label>请输入验证码</label>
          </div>
        </div>
        <div class="axj_certification_body_yzm_item_remark">
          <div class="axj_certification_yzm_normal_item_remark_label" v-show="false">
            <label>请填写与《机构认证申请公函》上的运营者姓名一致，在认证审核过程中，将与该运营者联系核实</label>
          </div>
        </div>
      </div>
      <div class="axj_certification_body_submit_item">
        <div class="axj_certification_body_submit_item_body">
          <div class="axj_certification_body_submit_item_body_left">

          </div>
          <div class="axj_certification_body_submit_item_body_rigth">
            <div class="submit-qx-button">
              <button @click="BackHome">返 &nbsp;回</button>
            </div>
            <div class="submit-qd-button">
              <button @click="verification">提 &nbsp;交</button>
            </div>
          </div>
        </div>
      </div>

    </div>
    <axj-file-preview
      :preview-files="preView.previewFiles"
      :preview-file-type="preView.previewFileType"
      :show-preview.sync="preView.showPreview"
    ></axj-file-preview>
  </div>
</template>

<script>
import AxjFilePreview from "../../../../../components/common/preview/index";
export default {
  name: "axj_certification_body",
  components: {AxjFilePreview},
  props:{
    userId:{
      type:Number,
      default:undefined
    }
  },
  methods:{
    BackHome(){
      this.$router.replace("/")
    },
    refreshExpiresTime(){
      setTimeout(res=>{
        this.expiresTime=this.expiresTime-1
        if(this.expiresTime>0){
          this.refreshExpiresTime()
        }
      },1000)
    },
    //用户尚未进行机构用户认证 是否去认证？
    sendLetterCode(){
      if(this.certificationForm.Phone.length<13){
        this.$refs.PhoneInput.style="border: 0.5px solid red;"
        this.$refs.PhoneInput.focus();
        this.$refs.PhoneMessage.style.visibility="visible"
        this.$refs.PhoneMessage.innerHTML="<label>请输入正确的手机号</label>"
        return
      }
      if(this.expiresTime==0){
        this.$api.commonApi.commonIndex.sendLetterCode({
          phone:this.certificationForm.Phone.replace(/[^\d]/g,"")
        }).then(res=>{

        })
        this.expiresTime=99
        this.refreshExpiresTime()
      }
    },
    uploadBusinessSuccess(res){
      this.axjBusinessUploadConf.preViewFileUrl=res.url
      this.certificationForm.MechanismPapers=res.url.substring(31,res.url.length)
    },
    handleNickNameInput(){
      if(this.certificationForm.NickName.length>10){
        this.certificationForm.NickName=this.certificationForm.NickName.substr(0,10);
      }
    },
    //预览组织机构代码
    handlePreView1(){
      this.preView.previewFiles=[]
      this.preView.previewFiles.push({url:this.certificationBodyFiles.zhuZhiJiGouDaiMa})
      this.preView.showPreview=true
    },
    handlePhoneKeyClick(v){
      if(v.code!='Backspace'){
        if(this.certificationForm.Phone.length==3
          ||this.certificationForm.Phone.length==8
        ){
          this.certificationForm.Phone=this.certificationForm.Phone+" "
        }
      }
    },
    handlePhoneInput(){

      if(this.certificationForm.Phone.length>13){
        this.certificationForm.Phone=this.certificationForm.Phone.substr(0,13);
      }
    },
    handleIdCardInput(v){
      if(this.certificationForm.IdCard.length>21){
        this.certificationForm.IdCard=this.certificationForm.IdCard.substr(0,21);
      }
    },
    handleIdCardKeyClick(v){
        if(v.code!='Backspace'){
          if(this.certificationForm.IdCard.length==6
            ||this.certificationForm.IdCard.length==11
            ||this.certificationForm.IdCard.length==16
          ){
            this.certificationForm.IdCard=this.certificationForm.IdCard+" "
          }
        }
    },
    uploadAvatarSuccess(res){
      this.axjAvatarUploadConf.preViewFileUrl=res.url
      this.certificationForm.Avatar=res.url.substring(31,res.url.length)
    },
    uploadLetterSuccess(res){
      this.axjLetterUploadConf.preViewFileUrl=res.url
      this.certificationForm.MechanismLetter=res.url.substring(31,res.url.length)
    },
    clearVerification(){
      this.$refs.NickNameInput.style="border: none"
      this.$refs.NickNameMessage.style.visibility="hidden"
      this.$refs.MechanismNameInput.style="border:none"
      this.$refs.MechanismNameMessage.style.visibility="hidden"
      this.$refs.IdCardInput.style="border:none"
      this.$refs.IdCardMessage.style.visibility="hidden"
      this.$refs.realNameInput.style="border: none"
      this.$refs.realNameMessage.style.visibility="hidden"
      this.$refs.PhoneInput.style="border: none;"
      this.$refs.PhoneMessage.style.visibility="hidden"
      this.$refs.CodeInput.style="border: none;"
      this.$refs.CodeMessage.style.visibility="hidden"
    },
    verificationLetterCode(){
      let form=this.certificationForm
      this.$api.commonApi.commonIndex.doLogin({
        identifier:form.Phone.replace(/[^\d]/g,""),
        credential:form.Code,
        type:"phone",
        device:'pc'
      }).then(res=>{
        if(res.code==200){
          this.submitCertificationForm()
        }else{
          this.$refs.CodeMessage.style.visibility="visible"
          this.$refs.CodeMessage.innerHTML="<label>短信验证码错误</label>"
        }
      },error => {
        this.$refs.CodeMessage.style.visibility="visible"
        this.$refs.CodeMessage.innerHTML="<label>短信验证码错误</label>"
        return false
      })
      return true
    },
    verificationForm(){
      this.clearVerification()
      let form=this.certificationForm
      if(form.NickName==""){
        this.$refs.NickNameInput.style="border: 0.5px solid red;"
        this.$refs.NickNameInput.focus();
        this.$refs.NickNameMessage.style.visibility="visible"
        this.$refs.NickNameMessage.innerHTML="<label>请输入账号昵称</label>"
      }else if(form.NickName.length<2){
        this.$refs.NickNameInput.style="border: 0.5px solid red;"
        this.$refs.NickNameInput.focus();
        this.$refs.NickNameMessage.style.visibility="visible"
        this.$refs.NickNameMessage.innerHTML="<label>长度在2-10个字符</label>"
      }
      else if(form.MechanismName==""){
        this.$refs.MechanismNameInput.style="border: 0.5px solid red;"
        this.$refs.MechanismNameInput.focus();
        this.$refs.MechanismNameMessage.style.visibility="visible"
        this.$refs.MechanismNameMessage.innerHTML="<label>请输入机构昵称</label>"
      }
      else if(form.RealName==""){
        this.$refs.realNameInput.style="border: 0.5px solid red;"
        this.$refs.realNameInput.focus();
        this.$refs.realNameMessage.style.visibility="visible"
        this.$refs.realNameMessage.innerHTML="<label>请输入运营者真实姓名</label>"
      }else if(form.IdCard.length<21){
        this.$refs.IdCardInput.style="border: 0.5px solid red;"
        this.$refs.IdCardInput.focus();
        this.$refs.IdCardMessage.style.visibility="visible"
        this.$refs.IdCardMessage.innerHTML="<label>请输入正确的身份证号</label>"
      }else if(form.Phone.length<13){
        this.$refs.PhoneInput.style="border: 0.5px solid red;"
        this.$refs.PhoneInput.focus();
        this.$refs.PhoneMessage.style.visibility="visible"
        this.$refs.PhoneMessage.innerHTML="<label>请输入正确的手机号</label>"
      }else if(form.Code==""){
        this.$refs.CodeInput.style="border: 0.5px solid red;"
        this.$refs.CodeInput.focus();
        this.$refs.CodeMessage.style.visibility="visible"
        this.$refs.CodeMessage.innerHTML="<label>请输入短信验证码</label>"
      }else{
        return true
      }
      return false
    },
    submitCertificationForm(){
      this.certificationForm.UserId=this.userId
      this.$api.axjWebApi.webAuth.AddAuths({
        ...this.certificationForm,
        Phone:this.certificationForm.Phone.replace(/[^\d]/g,""),
      }).then(res=>{
        if(res.code==200){
          this.$message({
            type:"success",
            message:"提交成功！预计1-7个工作日内审核完毕"
          })
          this.BackHome()
        }
      },error=>{
      })
    },
    verification(){
      if(!this.verificationForm()){
        this.$message({
          type:"error",
          message:"请完善表单后提交！"
        })
        return
      }
      this.verificationLetterCode()
    }
  },
  data(){
    return{
      certificationBodyFiles:{
        zhuZhiJiGouDaiMa:'/axj_web_file/axj_certfication/axj_web_certification_zhuzhijigoushili.png'
      },
      preView:{
        showPreview:false,
        previewFileType:'image',
        previewFiles:[]
      },
      expiresTime:0,
      axjBusinessUploadConf:{
        preViewFileUrl:undefined
      },
      axjAvatarUploadConf:{
        preViewFileUrl:undefined
      },
      axjLetterUploadConf:{
        preViewFileUrl:undefined
      },
      certificationForm:{
        Status:"",
        NickName:"",
        UserId:"",
        Avatar:"",
        MechanismName:"",
        MechanismType:0,
        MechanismPapers:"",
        MechanismLetter:"",
        RealName:"",
        IdCard:"",
        Phone:"",
        Code:""
      }
    }
  }
}
</script>

<style slot-scope lang="scss">
.link{
  color: #3a8ee6;
  cursor: pointer;
}
.notNull:after {
  content: '* ';
  color: red;
  margin-left: 4px;
}
.axj_certification_body{
  flex: 1;
  padding-bottom: 50px;
  display: flex;
  .axj_certification_body_do_cert{
    margin-left: 230px;
    margin-top: 40px;
    display: flex;
    flex-flow: column;
    .axj_certification_body_normal_item:not(:first-child){
      margin-top: 30px;
    }
    .axj_certification_body_yzm_item{
      display: flex;
      flex-flow: column;
      margin-top: 30px;
      .axj_certification_body_yzm_item_body{
        width: 700px;
        display: flex;
        .axj_certification_body_yzm_item_body_input{
          display: flex;
          input{
            width: 175px;
            height: 35px;
            border: none;
            outline: none;
            background: rgba(255, 255, 255, 0.1);
            color: #ffffff;
            border-radius: 2px;
            font-size: 14px;
          }
          input::-webkit-input-placeholder{
            color: #51515f;
          }
          input:focus{
            border-bottom-color: #00ADB5;;
          }
        }
        .axj_certification_body_yzm_item_body_button{
          display: flex;
          margin-left: 25px;
          width: 195px;
          button{
            width: 150px;
            height: 35px;
            cursor: pointer;
            border: none;
            //background: linear-gradient(276.5deg, rgba(0, 0, 0, 0.55) 0%, rgba(0, 0, 0, 0) 100%), rgba(255, 0, 0, 0.6);
            background-color: #3a8ee6;
            color: #ffffff;
            border-radius: 2px;
            outline: none;
          }
        }
        .axj_certification_body_yzm_item_body_label{
          width: 150px;
          display: flex;
          align-items: center;
          color: #ffffff;
          font-size: 16px;
        }
        .axj_certification_body_yzm_item_body_message{
          visibility: hidden;
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          margin-left: 10px;
          color: red;
        }
      }
      .axj_certification_body_yzm_item_remark{
        width: 700px;
        display: flex;
        .axj_certification_body_yzm_item_remark_label{
          margin-left: 150px;
          width: 350px;
          font-size: 12px;
          color: #7c858d;
          margin-top: 10px;
        }
      }
    }
    .axj_certification_body_normal_item{
      display: flex;
      flex-flow: column;
      align-items: flex-end;
      .axj_certification_body_normal_item_body{
        width: 700px;
        display: flex;
        .axj_certification_body_normal_item_body_input{
          input{
            width: 350px;
            height: 35px;
            border: none;
            outline: none;
            background: rgba(255, 255, 255, 0.1);
            color: #ffffff;
            border-radius: 2px;
            font-size: 14px;

          }
          input::-webkit-input-placeholder{
            color: #51515f;
          }
          input:focus{
            border-bottom-color: #00ADB5;;
          }
        }
        .axj_certification_body_normal_item_body_select{
          select{
            width: 350px;
            height: 35px;
            border: none;
            outline: none;
            background: rgba(255, 255, 255, 0.1);
            color: #ffffff;
            border-radius: 2px;
            font-size: 14px;
            border: none;
          }
        }
        .axj_certification_body_normal_item_body_label{
          width: 150px;
          display: flex;
          align-items: center;
          color: #ffffff;
          font-size: 16px;
        }
        .axj_certification_body_normal_item_body_message{
          visibility: hidden;
          font-size: 12px;
          display: flex;
          align-items: center;
          margin-left: 10px;
          color: red;
        }
      }
      .axj_certification_body_normal_item_remark{
        width: 700px;
        display: flex;
        .axj_certification_body_normal_item_remark_label{
          margin-left: 150px;
          width: 350px;
          font-size: 12px;
          color: #7c858d;
          margin-top: 10px;
        }
      }
    }
    .axj_certification_body_submit_item{
      display: flex;
      align-items: center;
      margin-top: 80px;
      margin-left: -50px;
      .axj_certification_body_submit_item_body{
        display: flex;
        width: 700px;
        .axj_certification_body_submit_item_body_left{
          width: 200px;
        }
        .axj_certification_body_submit_item_body_rigth{
          display: flex;
          width: 350px;
          .submit-qd-button{
            flex: 1;
            display: flex;
            justify-content: flex-end;
            button{
              width: 120px;
              height: 50px;
              border: none;
              background: linear-gradient(276.5deg, rgba(0, 0, 0, 0.55) 0%, rgba(0, 0, 0, 0) 100%), rgba(255, 0, 0, 0.6);
              color: #ffffff;
              border-radius: 2px;
              outline: none;
            }
            button:hover{
              cursor:pointer;
            }
          }
          .submit-qx-button{
            flex: 1;
            display: flex;
            justify-content: flex-start;
            button{
              width: 120px;
              height: 50px;
              border: none;
              background: rgba(255, 255, 255, 0.2);
              color: #ffffff;
              border-radius: 2px;
              outline: none;
            }
            button:hover{
              cursor:pointer;
            }
          }
        }
      }

    }
    .axj_certification_body_file_item{
      display: flex;
      align-items: flex-end;
      margin-top: 30px;
      .axj_certification_body_file_item_body{
        display: flex;
        width: 700px;
        .axj_certification_body_file_item_body_label{
          width: 150px;
          display: flex;
          align-items: center;
          color: #ffffff;
          font-size: 16px;
        }
        .axj_certification_body_file_item_body_input{
          button{
            width: 130px;
            height: 130px;
            border: none;
            outline: none;
            background: rgba(255, 255, 255, 0.1);
            color: #51515f;
            border-radius: 2px;
            font-size: 14px;
            border: none;
            background-size: 100%;
          }
          input::-webkit-input-placeholder{
            color: #b5b6bc;
          }
          input:focus{
            border-bottom-color: #00ADB5;;
          }
        }
        .axj_certification_body_file_item_body_remark{
          display: flex;
          width: 200px;
          flex-flow: column;
          margin-left: 10px;
          .axj_certification_body_file_item_body_remark_label{
            font-size: 12px;
            color: #7c858d;
            .el-link--inner{
              font-size: 12px;
            }
          }
          .axj_certification_body_file_item_body_remark_message_label{
            visibility: hidden;
            color: red;
            margin-top: 10px;
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/axj_web/axj_certification/component/axj_certfication_body/index.vue